import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Purge stale tile cache from previous service worker version
if ('caches' in window) {
  caches.delete('map-tiles')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
